export const BALANCE_ADJUSTMENT_MODE = {
  ADD: "add",
  SUBTRACT: "subtract",
  SET: "set",
};

const toNumber = (value) => Number.parseFloat(value);

export const calculateBalanceAdjustment = (currentBalance, mode, value) => {
  const parsedCurrentBalance = toNumber(currentBalance);
  const enteredAmount = toNumber(value);
  const safeCurrentBalance = Number.isNaN(parsedCurrentBalance)
    ? 0
    : parsedCurrentBalance;

  if (Number.isNaN(enteredAmount) || enteredAmount < 0) {
    throw new Error("Please enter a valid amount");
  }

  if (mode === BALANCE_ADJUSTMENT_MODE.ADD) {
    return {
      delta: enteredAmount,
      newBalance: safeCurrentBalance + enteredAmount,
    };
  }

  if (mode === BALANCE_ADJUSTMENT_MODE.SUBTRACT) {
    if (safeCurrentBalance >= 0 && enteredAmount > safeCurrentBalance) {
      throw new Error("Subtraction amount exceeds current balance");
    }
    return {
      delta: -enteredAmount,
      newBalance: safeCurrentBalance - enteredAmount,
    };
  }

  if (mode === BALANCE_ADJUSTMENT_MODE.SET) {
    const delta = enteredAmount - safeCurrentBalance;
    if (delta === 0) {
      throw new Error("No balance change detected");
    }
    return {
      delta,
      newBalance: enteredAmount,
    };
  }

  throw new Error("Invalid adjustment type");
};

export const buildBalanceAdjustmentDetails = ({
  mode,
  previousBalance,
  newBalance,
  userDetails,
}) => {
  const modeLabel =
    mode === BALANCE_ADJUSTMENT_MODE.ADD
      ? "Add balance"
      : mode === BALANCE_ADJUSTMENT_MODE.SUBTRACT
      ? "Subtract balance"
      : "Set actual balance";
  const systemDetails = `${modeLabel} | Previous: ${previousBalance} | New: ${newBalance}`;
  return userDetails?.trim()
    ? `${userDetails.trim()} | ${systemDetails}`
    : systemDetails;
};
